import { render, staticRenderFns } from "./GroupAction.vue?vue&type=template&id=403bec73"
import script from "./GroupAction.vue?vue&type=script&lang=js"
export * from "./GroupAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports